export class Service {
  protected readonly root: string;

  constructor() {
    if (typeof window != 'undefined' && process.env.NODE_ENV !== 'production') {
      this.root = process.env.NEXT_PUBLIC_API_ENDPOINT_CLIENT_SIDE!;
    } else {
      this.root = process.env.NEXT_PUBLIC_API_ENDPOINT!;
    }
  }
}
